import { route as paymentFormRoute } from './pages/payment_form';
import { createShell } from '../../shell/createShell';
import { PaymentFormFunnel } from '.';
const routes = [paymentFormRoute];
export const paymentFormShell = createShell(PaymentFormFunnel, {
  options: {
    routes,
    namespace: 'payment_form',
    disableTracking: true
  }
});